import Const from 'constants';

const FilterLineupsByTeamCombinations = {
    filterLineupsByCheckedTeamsCombo(checkedCombo) {
        return (dispatch, getState) => {
            const {combo, isChecked} = checkedCombo;
            const {filterLineupsByTeamCombinations} = getState();
            const combinations = filterLineupsByTeamCombinations.getCheckedCombinations();

            const checkedCombinations = Boolean(isChecked)
                ? [...combinations, combo]
                : combinations.filter((checkedCombo) => checkedCombo.getUnitId() !== combo.getUnitId());

            dispatch(this.setLineupsFilterByCheckedTeamsCombinations(checkedCombinations));
        };
    },

    setLineupsFilterByCheckedTeamsCombinations(checkedCombinations) {
        return (dispatch, getState) => {
            const {lineupTeamCombinationsMap} = getState();

            const lineupIds = lineupTeamCombinationsMap.getLineupIdsByCheckedCombinations(checkedCombinations);

            dispatch({
                type: Const.FILTER_LINEUPS_BY_TEAM_COMBINATIONS_SET_COMBO,
                data: {
                    checkedCombinations,
                    lineupIds,
                },
            });
        };
    },
};

export default FilterLineupsByTeamCombinations;
